var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"FV-reset-wr\">\n	<div class=\"reset-lbl-wr\">\n		<span data-spin-holder=\"true\"></span>\n		<span class=\"reset-loading-label\">Loading ...</span>\n	</div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/resetPlaceholder/template.hbs
 ** module id = 559
 ** module chunks = 0
 **/